<template>
	<el-table :data="items" height="250" border show-summary size="mini" style="width: 100%">
		<el-table-column type="index" :index="1"></el-table-column>
		<el-table-column
			:prop="key.name"
			:label="dataModels.Tx_item[key.name].show_name"
			:sortable="key.sortable"
			:key="index"
			:width="key.width"
			v-for="(key,index) in itemFields"
		>
			<div slot-scope="scope">
				<span v-if="key.isOnlyShow && key.render" v-html="key.render(scope.row)"></span>
				<field-show
					:field-info="dataModels.Tx_item[key.name]"
					:value="scope.row[key.name]"
					:field-key="key"
					v-else-if="key.isOnlyShow"
				></field-show>
				<field-editor
					:width="key.width"
					:tips="key.tips"
					v-model="scope.row[key.name]"
					:field-info="dataModels.Tx_item[key.name]"
					:record-id="recordId"
					record-model="Tx_item"
					@change="onChange(scope.$index)"
					:params="key.params"
					v-else
				></field-editor>
			</div>
		</el-table-column>
		<el-table-column fixed="right" label="操作">
			<template slot-scope="scope">
				<el-button @click="handleRemove(scope.$index)" type="text" size="small">
					<i class="el-icon-delete"></i>
				</el-button>
			</template>
		</el-table-column>
	</el-table>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	data() {
		return {
			loadings: {
				main: false,
				create: false,
				insert: false,
			},
			recordId: "",
			activeName: "op",
		};
	},
	computed: {
		...mapState(["dataModels", "loadingDM"]),
		items: {
			get: function() {
				return this.value;
			},
			set: function(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", newValue);
			},
		},
		hasGetTableDataModel() {
			if (this.dataModels["Tx_item"] && this.dataModels["Tx_item"]._id) {
				return true;
			} else {
				return false;
			}
		},
		itemFields() {
			if (this.isNeedCost) {
				return [
					{
						name: "brand_show_id",
						isOnlyShow: true,
					},
					{
						name: "brand",
						isOnlyShow: true,
					},
					{
						name: "product_color",
						isOnlyShow: true,
						width: "200px",
					},

					{
						name: "model",
						isOnlyShow: true,
					},
					{
						name: "price_per",
					},
					{
						name: "amount",
					},
					{
						name: "total_price",
						isOnlyShow: true,
					},
				];
			} else {
				return [
					{
						name: "brand_show_id",
						isOnlyShow: true,
					},
					{
						name: "brand",
						isOnlyShow: true,
					},
					{
						name: "product_color",
						isOnlyShow: true,
					},
					{
						name: "color",
						isOnlyShow: true,
					},
					{
						name: "model",
						isOnlyShow: true,
					},
					{
						name: "amount",
					},
				];
			}
		},
	},
	props: {
    bianMa: {
      type: String,
      default: '',
    },
		value: {
			type: Array,
			default: function() {
				return [];
			},
		},
		isNeedCost: {
			type: Boolean,
			default: true,
		},
		withPrice: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		doResetAll() {
			this.items = [];
		},
		handleRemove(index) {
			this.items.splice(index, 1);
		},
		onChange(index) {
			this.items[index].total_price = (
				this.items[index].price_per * this.items[index].amount
			).toFixed(2);
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
